export const getWhatsNewApi = ( query) => {
    const queryString = new URLSearchParams(query).toString();
    return `api/features/${queryString ? `?${queryString}` : ""}`;
};
